import { render, staticRenderFns } from "./subSkiiScoreList.vue?vue&type=template&id=38b904e9&scoped=true"
import script from "./subSkiiScoreList.vue?vue&type=script&lang=js"
export * from "./subSkiiScoreList.vue?vue&type=script&lang=js"
import style0 from "./subSkiiScoreList.vue?vue&type=style&index=0&id=38b904e9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b904e9",
  null
  
)

export default component.exports